<script setup lang="ts">
interface Props {
  text?: string;
  height?: number;
  buttonPadding?: string;
}

const props = withDefaults(defineProps<Props>(), {
  text: "続きを見る",
  height: 300,
  buttonPadding: "1rem",
});

const accordionHeight = ref(props.height);
const accordion = ref<HTMLElement | null>(null);
const isOpen = ref(false);

watch(
  () => isOpen.value,
  () => {
    if (!accordion.value) return;
    if (isOpen.value) {
      accordionHeight.value = accordion.value.scrollHeight;
    } else {
      accordionHeight.value = props.height;
    }
  },
);
// スロットの中身が変わったら閉じる（高さ違い対策)
const slots = defineSlots();
const slot = computed(() => {
  return slots.default()[0].children;
});

watch(
  () => slot.value,
  () => {
    isOpen.value = false;
  },
);
</script>

<template>
  <div>
    <div
      ref="accordion"
      class="target shadow overflow-hidden p-2"
      :class="{ isOpen: isOpen }"
      :style="{ height: accordionHeight + 'px' }"
    >
      <slot />
      <button
        class="sticky w-full bottom-0 z-10 border bg-gray-100 hover:bg-gray-200"
        :style="{ padding: buttonPadding }"
        type="button"
        :aria-label="isOpen ? '閉じる' : '開く'"
        @click="isOpen = !isOpen"
      >
        <span v-if="text">{{ isOpen ? "閉じる" : text }}</span>
        <Icon
          size="32"
          :name="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'"
        />
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.target {
  transition: height 0.4s ease-in-out;
  position: relative;
  &:after {
    @apply block w-full h-full absolute bottom-0 left-0 bg-gradient-to-b to-white from-transparent;
    content: "";
  }
  &.isOpen {
    &:after {
      opacity: 0;
      z-index: -1;
    }
  }
}
</style>
